export const FEATURE_STORE_GATE = 'Growth:FeatureStore';
export const CBX_FEATURE_STORE_GATE = 'CBX:FeatureStore';
export const SEATS_FREE_TO_PRO_TOUCHLESS_FLOW_GATE = 'CBX:SeatsFreeToProTouchlessFlow';
export const SEATS_FREE_TO_STARTER_TOUCHLESS_FLOW_GATE = 'CBX:SeatsFreeToStarterTouchlessFlow';
export const CBX_FEATURE_STORE_BUSINESS_OBJECTIVES_GATE = 'CBX:FeatureStoreBusinessObjectives';
export const CBX_FEATURE_STORE_DEFAULT_CONTENT_GATE = 'CBX:FeatureStoreDefaultContent';